import * as React from "react";
import { cn } from "../../lib/utils";

const badgeVariants = {
  default: "ui-badge ui-badge-default",
  secondary: "ui-badge ui-badge-secondary",
  destructive: "ui-badge ui-badge-destructive",
  outline: "ui-badge ui-badge-outline",
  success: "ui-badge ui-badge-success",
  warning: "ui-badge ui-badge-warning",
  info: "ui-badge ui-badge-info",
};

const Badge = React.forwardRef(({ className, variant = "default", ...props }, ref) => (
  <span ref={ref} className={cn(badgeVariants[variant], className)} {...props} />
));

Badge.displayName = "Badge";

export { Badge };
